<template>
    <div>
        <b-card
            bg-variant="light"
            header="Upload climate files"
            header-class="card-header  p-3 h5"
            header-text-variant="black"
            header-tag="header"
        >
            <div class="alert mt-4 alert-warning" role="alert">
                Climate files have to be in such a format:
                {climate}-{location}-{direction}.idf (eg. A-AboveColumn-0.idf)
            </div>
            <div class="grid2x2">
                <div>
                    <span
                        class="d-flex justify-content-center align-items-center"
                    >
                        Dropzone for Climate A
                    </span>

                    <vue-dropzone
                        :id="customRefsForClimates.A"
                        :ref="customRefsForClimates.A"
                        class="d-flex justify-content-center align-items-center flex-wrap"
                        :options="multiDropzoneOptions"
                        @vdropzone-sending-multiple="sendingFile"
                        @vdropzone-success-multiple="onSuccess"
                    />

                    <div class="justify-content-center align-items-baseline">
                        <uploaded-files-modal
                            v-if="showButtonForClimateA"
                            :items="filesToShow.climateA"
                            style="flex-direction:column; "
                            class="mt-1 ml-2 pr-4"
                            @onClick="getClimateFiles('A')"
                            @onAgree="removeAllSelectedFiles"
                        />
                        <div class="justify-content-center mt-1">
                            <button
                                class="btn  btn-success waves-effect waves-light "
                                data-animation="fadein"
                                data-overlaycolor="#38414a"
                                @click="uploadFiles(customRefsForClimates.A)"
                            >
                                Upload files
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <span
                        class="d-flex justify-content-center align-items-center"
                    >
                        Dropzone for Climate B
                    </span>

                    <vue-dropzone
                        :id="customRefsForClimates.B"
                        :ref="customRefsForClimates.B"
                        class="d-flex justify-content-center align-items-center flex-wrap"
                        :options="multiDropzoneOptions"
                        @vdropzone-sending-multiple="sendingFile"
                        @vdropzone-success-multiple="onSuccess"
                    />
                    <div class="justify-content-center align-items-baseline">
                        <uploaded-files-modal
                            v-if="showButtonForClimateB"
                            :items="filesToShow.climateB"
                            style="flex-direction:column; align-items:center;"
                            class="mt-1 ml-2 pr-4"
                            @onClick="getClimateFiles('B')"
                            @onAgree="removeAllSelectedFiles"
                        />
                        <div class="justify-content-center mt-1">
                            <button
                                class="btn  btn-success waves-effect waves-light "
                                data-animation="fadein"
                                data-overlaycolor="#38414a"
                                @click="uploadFiles(customRefsForClimates.B)"
                            >
                                Upload files
                            </button>
                        </div>
                    </div>
                </div>

                <div>
                    <span
                        class="d-flex justify-content-center align-items-center"
                    >
                        Dropzone for Climate C
                    </span>

                    <vue-dropzone
                        :id="customRefsForClimates.C"
                        :ref="customRefsForClimates.C"
                        class="d-flex justify-content-center align-items-center flex-wrap"
                        :options="multiDropzoneOptions"
                        @vdropzone-sending-multiple="sendingFile"
                        @vdropzone-success-multiple="onSuccess"
                    />
                    <div class="justify-content-center align-items-baseline">
                        <uploaded-files-modal
                            v-if="showButtonForClimateC"
                            :items="filesToShow.climateC"
                            style="flex-direction:column; align-items:center;"
                            class="mt-1 ml-2 pr-4"
                            @onClick="getClimateFiles('C')"
                            @onAgree="removeAllSelectedFiles"
                        />
                        <div class="justify-content-center mt-1">
                            <button
                                class="btn  btn-success waves-effect waves-light "
                                data-animation="fadein"
                                data-overlaycolor="#38414a"
                                @click="uploadFiles(customRefsForClimates.C)"
                            >
                                Upload files
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <span
                        class="d-flex justify-content-center align-items-center"
                    >
                        Dropzone for Climate D
                    </span>

                    <vue-dropzone
                        :id="customRefsForClimates.D"
                        :ref="customRefsForClimates.D"
                        class="d-flex justify-content-center align-items-center flex-wrap"
                        :options="multiDropzoneOptions"
                        @vdropzone-sending-multiple="sendingFile"
                        @vdropzone-success-multiple="onSuccess"
                    />
                    <div class="justify-content-center align-items-baseline">
                        <uploaded-files-modal
                            v-if="showButtonForClimateD"
                            :items="filesToShow.climateD"
                            style="flex-direction:column; align-items:center;"
                            class="mt-1 ml-2 pr-4"
                            @onClick="getClimateFiles('D')"
                            @onAgree="removeAllSelectedFiles"
                        />
                        <div class="justify-content-center mt-1">
                            <button
                                class="btn btn-success waves-effect waves-light "
                                data-animation="fadein"
                                data-overlaycolor="#38414a"
                                @click="uploadFiles(customRefsForClimates.D)"
                            >
                                Upload files
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>

        <br />

        <b-card
            v-if="withWeatherFiles"
            bg-variant="light"
            header="Upload static weather files"
            header-class="card-header  p-3 h5"
            header-text-variant="black"
            header-tag="header"
        >
            <vue-dropzone
                :id="customRefForWeatherFiles"
                :ref="customRefForWeatherFiles"
                class="d-flex justify-content-center align-items-center flex-wrap"
                :options="{
                    ...multiDropzoneOptions,
                    dictDefaultMessage: `Click Here </br> or </br> Drop  Weather Files <i class='fe-upload'></i>`,
                    acceptedFiles: '.epw'
                }"
                @vdropzone-sending-multiple="sendingFile"
                @vdropzone-success-multiple="onSuccess"
            />
            <div
                class="mt-2 d-flex justify-content-center align-items-baseline"
            >
                <uploaded-files-modal
                    v-if="showButtonForWeatherFiles"
                    :items="filesToShow.weatherFiles"
                    style="flex-direction:column; align-items:center;"
                    class="mt-1 ml-2 pr-4"
                    @onClick="getWeatherFiles"
                    @onAgree="removeAllSelectedFiles"
                />
                <div class="justify-content-center mt-1">
                    <button
                        class="btn btn-success waves-effect waves-light"
                        data-animation="fadein"
                        data-overlaycolor="#38414a"
                        @click="uploadFiles(customRefForWeatherFiles)"
                    >
                        Upload files
                    </button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import vueDropzone from 'vue2-dropzone';
import uploadedFilesModal from '@/components/elements/UploadedFilesModal';

export default {
    components: {
        vueDropzone,
        uploadedFilesModal
    },

    props: {
        withWeatherFiles: {
            type: Boolean,
            default: false
        },
        climateFilesType: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            settings: [],
            filesToShow: {
                climateA: [],
                climateB: [],
                climateC: [],
                climateD: [],
                weatherFiles: []
            },
            files: [],

            showButtonForWeatherFiles: false,
            showButtonForClimateA: false,
            showButtonForClimateB: false,
            showButtonForClimateC: false,
            showButtonForClimateD: false,

            dropzoneRelativePath: `/files`,
            selectedClimate: null,
            file: {},
            selectedFile: [],
            climates: [
                { key: 'A', label: 'ClimateA' },
                { key: 'B', label: 'ClimateB' },
                { key: 'C', label: 'ClimateC' },
                { key: 'D', label: 'ClimateD' }
            ],
            multipleMode: {
                type: Boolean,
                required: false,
                default: false
            }
        };
    },

    computed: {
        multiDropzoneOptions() {
            const options = {
                url: process.env.VUE_APP_API_URL + this.dropzoneRelativePath,
                thumbnailWidth: 150,
                maxFilesize: 200,
                timeout: 120000,
                uploadMultiple: true,
                acceptedFiles: '.idf',
                dictDefaultMessage:
                    "Click Here </br> or </br> Drop Climate Files <i class='fe-upload'></i>",
                addRemoveLinks: true,
                duplicateCheck: true,
                withCredentials: true,
                autoProcessQueue: false,
                parallelUploads: 100
            };

            return options;
        },

        customRefsForClimates() {
            const selected = {
                A:
                    Math.random()
                        .toString(36)
                        .substring(2, 30)
                        .match(/[a-zA-Z]+/g)
                        .join('') + 'FileDropzoneForClimateA',

                B:
                    Math.random()
                        .toString(36)
                        .substring(2, 30)
                        .match(/[a-zA-Z]+/g)
                        .join('') + 'FileDropzoneForClimateB',
                C:
                    Math.random()
                        .toString(36)
                        .substring(2, 30)
                        .match(/[a-zA-Z]+/g)
                        .join('') + 'FileDropzoneForClimateC',
                D:
                    Math.random()
                        .toString(36)
                        .substring(2, 30)
                        .match(/[a-zA-Z]+/g)
                        .join('') + 'FileDropzoneForClimateD'
            };

            return selected;
        },

        customRefForWeatherFiles() {
            return (
                Math.random()
                    .toString(36)
                    .substring(2, 30)
                    .match(/[a-zA-Z]+/g)
                    .join('') + 'WeatherFilesDropzone'
            );
        }
    },

    watch: {
        value: {
            async handler() {
                let files = [];

                if (Array.isArray(this.value)) {
                    files = [...this.value];
                } else if (
                    (this.value && this.value.id) ||
                    (typeof this.value === 'string' && this.value)
                ) {
                    files = [this.value];
                }

                this.files = await Promise.all(
                    files.map(async item => {
                        return item.id ? item : await this.getFile(item);
                    })
                );
            },
            immediate: true
        }
    },

    async created() {
        await this.checkFilesExists();

        this.settings = await this.getSettings();
    },

    methods: {
        ...mapActions({
            getFiles: 'files/index',
            deleteFiles: 'files/delete',
            getSettings: 'settings/index'
        }),

        async getWeatherFiles() {
            const { rows } = await this.getFiles({
                searchParams: { type: 'weather_files' }
            });

            this.filesToShow['weatherFiles'] = rows;
        },

        async removeAllSelectedFiles(filesToDelete) {
            try {
                for (const file of filesToDelete) {
                    await this.deleteFiles(file.id);
                }

                this.$bvToast.toast('Files has been deleted', {
                    title: 'Success!',
                    variant: 'success',
                    solid: true
                });

                await this.checkFilesExists();
            } catch (error) {
                console.error(error);

                this.$bvToast.toast('Error while deleting the files', {
                    title: 'Error!',
                    variant: 'error',
                    solid: true
                });
            }
        },

        async checkFilesExists() {
            const { rows } = await this.getFiles({});

            this.showButtonForWeatherFiles = rows.some(
                file => file.type === 'weather_files'
            );

            this.showButtonForClimateA = rows.some(
                file =>
                    file.climate === 'A' && file.type === this.climateFilesType
            );

            this.showButtonForClimateB = rows.some(
                file =>
                    file.climate === 'B' && file.type === this.climateFilesType
            );

            this.showButtonForClimateC = rows.some(
                file =>
                    file.climate === 'C' && file.type === this.climateFilesType
            );

            this.showButtonForClimateD = rows.some(
                file =>
                    file.climate === 'D' && file.type === this.climateFilesType
            );
        },

        async getClimateFiles(climate) {
            const { rows } = await this.getFiles({
                searchParams: { climate, type: this.climateFilesType }
            });

            this.filesToShow[`climate${climate}`] = rows;
        },

        sendingFile(file, xhr, formData) {
            const files = Array.from(file);

            if (!files.some(file => file.name.match(/.epw$/g))) {
                formData.append('type', this.climateFilesType);
                formData.append('climate', this.selectedClimate);
                formData.append('isSettingFile', true);
            } else {
                formData.append('type', 'weather_files');
            }

            xhr.setRequestHeader(
                'cluid',
                JSON.parse(window.localStorage.getItem('auth.currentUser')).id
            );

            return formData;
        },

        async uploadFiles(dropZoneRef) {
            this.climates.some(
                climate =>
                    dropZoneRef.includes(climate.label) &&
                    (this.selectedClimate = climate.key)
            );

            this.$refs[dropZoneRef].processQueue();
        },

        async onSuccess(files, response) {
            this.$bvToast.toast('Files has been uploaded.', {
                title: 'Success!',
                variant: 'success',
                solid: true
            });

            if (this.multipleMode) {
                this.selectedFile = [...this.selectedFile, ...response];
            } else {
                this.selectedFile = [response[0]];
            }

            this.selectedFile = this.selectedFile.map(file => {
                return file;
            });
            const isWeatherFile = files.some(file => file.name.match(/.epw$/g));

            this.$refs[
                isWeatherFile
                    ? this.customRefForWeatherFiles
                    : this.customRefsForClimates[this.selectedClimate]
            ].removeAllFiles();

            await this.checkFilesExists();
        }
    }
};
</script>

<style></style>
